var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaylist02 = function SvgPlaylist02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6C89",
    strokeWidth: 1.5,
    d: "M1.664 7.497c0-2.75 0-4.124.854-4.979.855-.854 2.23-.854 4.98-.854h1.666c2.75 0 4.125 0 4.98.854.853.855.853 2.23.853 4.98v1.666c0 2.75 0 4.125-.854 4.98-.854.853-2.23.853-4.979.853H7.497c-2.75 0-4.124 0-4.979-.854-.854-.854-.854-2.23-.854-4.979z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6C89",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M15.201 5.836c1.113.068 1.82.254 2.332.764.803.804.803 2.097.803 4.683v1.567c0 2.586 0 3.88-.803 4.683-.804.803-2.097.803-4.683.803h-1.567c-2.586 0-3.88 0-4.683-.803-.51-.511-.696-1.22-.764-2.332"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6C89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.17 10V5c.184.333.333 1.733 1.666 2m-1.667 3a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0"
  })));
};
export default SvgPlaylist02;